/*
Dates in the XOL-596 notices ("Changed by Ann Lee on 13 Oct 2026 10:47 pm", "locked on
…", "closed by … on …").

The notices are built outside any component, from the app root. The root does NOT carry
the date helpers (`formatDate` / `formatDateTime` live in DateMixins, which components
mix in), so asking `root.formatDate` found nothing and the notices printed the raw
server value (`2026-10-13T22:47:56+08:00`, `2026-10-13 09:12:00`). These go through the
SAME helpers the field cue uses (FieldCue mixes in DateMixins), which resolve every value
on the app clock (lib/appTime: a bare wire string is relabelled, an offset-bearing one
converted; never `utcOffset(x, true)`).

    formatNoticeDate(root, v)       "13 Oct 2026"
    formatNoticeDateTime(root, v)   "13 Oct 2026 10:47 pm"

A value that is not a date comes back as it was (a notice never shows "null").
ES5, no optional chaining or nullish coalescing.
------------------------------------------------------------------------ */

import DateMixins from '@/mixins/DateMixins'

var methods = DateMixins.methods

function pick (root, name, v) {
  if (v === null || v === undefined || v === '') {
    return null
  }

  // A root (or a spec's stand-in) that carries its own formatter wins.
  var formatted = root && typeof root[name] === 'function' ? root[name](v) : methods[name](v)

  return formatted === null || formatted === undefined ? String(v) : formatted
}

export function formatNoticeDate (root, v) {
  return pick(root, 'formatDate', v)
}

export function formatNoticeDateTime (root, v) {
  return pick(root, 'formatDateTime', v)
}
